<div class="pro-modal-header">
  <div class="d-flex align-items-center gap-3">
    <img [src]="pro.image | proImage" class="pro-avatar-sm" [alt]="pro.lastname" *ngIf="pro.image">
    <div class="pro-avatar-sm-placeholder" *ngIf="!pro.image">
      <span class="material-icons">person</span>
    </div>
    <div class="pro-modal-info">
      <h4 class="pro-modal-name">{{ pro.firstname }} {{ pro.lastname }}</h4>
      <div class="modal-info-row" style="padding: 0" *ngIf="pro.address || pro.city">
        <span class="material-icons">location_on</span>
        <span>{{ pro.address }}<ng-container *ngIf="pro.address && pro.city">, </ng-container>{{ pro.city }} {{ pro.zipCode }}</span>
      </div>
      <span class="pro-modal-email-badge" *ngIf="pro.email">{{ pro.email }}</span>
    </div>
  </div>
  <button class="pro-modal-close" aria-label="Close" (click)="closeModal()">
    <span class="material-icons-outlined">close</span>
  </button>
</div>

<div class="modal-body">

  <span class="modal-badge modal-badge-visio" *ngIf="pro.visio">
    <span class="material-icons">videocam</span>
    Séances disponibles en visio
  </span>

  <p style="font-size: 0.9rem; color: #555; line-height: 1.7; margin-top: 0.75rem" *ngIf="pro.description">{{ pro.description }}</p>

  <ng-container *ngIf="pro.formations && pro.formations.length >= 1">
    <div class="pro-modal-section-title">
      <span class="material-icons">school</span>
      Formations
    </div>
    <div class="pro-modal-formation-item" *ngFor="let formation of pro.formations">
      <span class="material-icons">check_circle</span>
      <span>{{ formation.title }}</span>
    </div>
  </ng-container>

  <div class="pro-modal-motivation" *ngIf="pro.motivation">
    <div class="pro-modal-section-title">
      <span class="material-icons">favorite</span>
      Pourquoi s'engager avec Opale.care ?
    </div>
    <p>{{ pro.motivation }}</p>
  </div>

</div>

<div class="modal-footer d-flex justify-content-between align-items-center">
  <div class="d-flex gap-3">
    <a href="{{ pro.facebook }}" class="social-link-text" target="_blank" *ngIf="pro.facebook">
      <img src="assets/images/social/facebook.svg" alt="facebook"> Facebook
    </a>
    <a href="{{ pro.instagram }}" class="social-link-text" target="_blank" *ngIf="pro.instagram">
      <img src="assets/images/social/instagram.svg" alt="instagram"> Instagram
    </a>
    <a href="{{ pro.website }}" class="social-link-text" target="_blank" *ngIf="pro.website">
      <img src="assets/images/social/website.svg" alt="site web"> Site web
    </a>
    <a href="{{ pro.linkedin }}" class="social-link-text" target="_blank" *ngIf="pro.linkedin">
      <img src="assets/images/social/linkedin.svg" alt="linkedin"> LinkedIn
    </a>
  </div>
  <button type="button" class="btn btn-primary text-white fw-semibold px-4" (click)="closeModal()">Fermer</button>
</div>
